
import WCurrencyDisplay from '~/components/global/w-currency-display/w-currency-display.vue'

export default {
  components: {
    WCurrencyDisplay,
  },
  props: {
    value: {
      type: Number,
      required: true,
    },
    formatter: {
      type: String,
      default: 'percentage',
    },
    numberFormat: {
      type: String,
      default: 'default',
    },
    blurCurrencyValue: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    sign() {
      return this.value < 0 ? '−' : '+'
    },
    color() {
      if (this.value > 0) {
        return 'positive'
      } else if (this.value < 0) {
        return 'negative'
      }
      return 'neutral'
    },
    formatterFunction() {
      if (this.formatter === 'currency') {
        return this.$formatAsCurrency
      }
      return this.$formatAsPercentage
    },
  },
}
